import { Injectable, inject, Signal } from '@angular/core';
import { ScreenSize, ToasterState } from '@lyceo/shared/util-models';
import { Store } from '@ngrx/store';
import * as ApplicationSelectors from './application.selectors';
import { ApplicationActions } from './application.actions';

@Injectable({
  providedIn: 'root',
})
export class ApplicationFacade {
  private readonly store: Store = inject(Store);

  public readonly isScreenSizeXs: Signal<boolean> = this.store.selectSignal(
    ApplicationSelectors.selectIsScreenSizeXs,
  );
  public readonly isScreenSizeSm: Signal<boolean> = this.store.selectSignal(
    ApplicationSelectors.selectIsScreenSizeSm,
  );
  public readonly isScreenSizeMd: Signal<boolean> = this.store.selectSignal(
    ApplicationSelectors.selectIsScreenSizeMd,
  );
  public readonly isScreenSizeLg: Signal<boolean> = this.store.selectSignal(
    ApplicationSelectors.selectIsScreenSizeLg,
  );
  public readonly isScreenSizeXl: Signal<boolean> = this.store.selectSignal(
    ApplicationSelectors.selectIsScreenSizeXl,
  );
  public readonly guardsLoaded: Signal<boolean> = this.store.selectSignal(
    ApplicationSelectors.selectGuardsLoaded,
  );

  public isAnyOfScreenSizes: (screenSizes: ScreenSize[]) => Signal<boolean> = (
    screenSizes: ScreenSize[],
  ) =>
    this.store.selectSignal(
      ApplicationSelectors.selectIsAnyOfScreenSizes(screenSizes),
    );

  public readonly isMobileScreenSize: Signal<boolean> = this.store.selectSignal(
    ApplicationSelectors.selectIsAnyOfScreenSizes([
      ScreenSize.XS,
      ScreenSize.SM,
      ScreenSize.MD,
    ]),
  );

  public init(): void {
    this.store.dispatch(ApplicationActions.init());
  }

  public showToaster(toaster: ToasterState): void {
    this.store.dispatch(ApplicationActions.showToaster({ toaster }));
  }
}
